<form [formGroup]="formGroup" [style.flex-direction]="direction()">
    @for (options of formDefinition(); track options.options.controlKey) {
        <ng-template appDynamicForm [parameters]="options"/>
    }
</form>



